<div class="counts" *ngIf="productionManagementCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >Prod Management
        <span>{{ productionManagementCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'productionManagementCounts', 'finished']"
      >
        <p class="count">Projects Finished</p>
        <span>{{ productionManagementCounts.finished }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'productionManagementCounts', 'pastDue']"
      >
        <p class="count">Projects Past Due</p>
        <span>{{ productionManagementCounts.pastDue }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'productionManagementCounts',
          'needsFollowUp'
        ]"
      >
        <p class="count">Projects Finished Needing Follow Up</p>
        <span>{{ productionManagementCounts.needsFollowUp }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'productionManagementCounts',
          'completed'
        ]"
      >
        <p class="count">Completed Projects</p>
      </div>
    </div>
  </mat-expansion-panel>
</div>
